import {Button, Card, Flex, Form, message, Select, Table, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {ReloadOutlined} from "@ant-design/icons";
import ListTable from "../ListTable/ListTable";
import {API} from "aws-amplify";
import dayjs from "dayjs";

const ReportsNoIdentification = (props) => {

    const [componentState, setComponentState] = useState({
        reportsList: [],
        FETCH_STATUS: 'LOADED',
        activeTeamId: 1,
        teamList: []
    });

    const buildColumns = () => {
        return [
            {
                title: 'ID',
                dataIndex: 'id',
                render: (text, record) => text,
                sorter: (a,b) => a.id - b.id,
                defaultSortOrder: 'descend',
                ...props.getColumnSearchProps({
                    dataIndex: 'id',
                    render: (text) => text
                })
            },
            {
                title: 'Client Name',
                dataIndex: 'nickname',
                ...props.getColumnSearchProps({
                    dataIndex: 'nickname',
                    render: (text, record) => {
                        return <a href={`/clients/edit/${record.client_id}`} target={"_blank"}>{record.nickname}</a>

                    }
                })
            },
            {
                title: 'Transfers (to today)',
                dataIndex: 'transfer_count_last_3_months',
                render: (text, record) => {
                    const zeroToThree = record.transfer_count_last_3_months;
                    const threeToSix = record.transfer_count_3_to_6_months;
                    const SixToNine = record.transfer_count_6_to_9_months;
                    const NineToTwelve = record.transfer_count_9_to_12_months;
                    const twelveToTwentyFour = record.transfer_count_12_to_24_months;
                    return <table>
                        <tr>
                            <td width={"20%"}>
                                3m: {zeroToThree || '--'}
                            </td>
                            <td width={'20%'}>
                                6m: {threeToSix || '--'}
                            </td>
                            <td width={'20%'}>
                                9m: {SixToNine || '--'}
                            </td>
                            <td width={'20%'}>
                                12m: {NineToTwelve || '--'}
                            </td>
                            <td width={'20%'}>
                                24m: {twelveToTwentyFour || '--'}
                            </td>
                        </tr>
                    </table>
                }
            },
            {
                title: 'Total Transfers',
                dataIndex: 'total_transfer_count',
                sorter: (a,b) => a.total_transfer_count - b.total_transfer_count,
                render: (text, record) => text
            },
            {
                title: 'Last Transfer',
                dataIndex: 'settlement_date',
                ...props.getColumnSearchProps({
                    dataIndex: 'settlement_date',
                    filterInputType: 'DATE',
                    render: (text, record) => text != null ? dayjs(text).format('DD/MM/YYYY') : '-'
                })
            },
        ]
    }

    const fetchTeams = () => {
        API.post("commons", "/fetch", {
            body: {
                context: 'teams',
                fields: ['*'],
                condition: {deleted: false},
            }
        }).then(res => {
            console.log(res);
            setComponentState(prev => ({...prev, teamList: res}));
        }).catch(err => {
            console.log(err);
        })
    }

    const init = () => {
        const loading = message.loading("Fetching...", 0);
        setComponentState(prev => ({...prev, FETCH_STATUS: 'LOADING'}));
        API.get("reports", `/clients/one-id-record-check/${componentState.activeTeamId}`, {}).then(response => {
            setComponentState(prev => ({...prev, reportsList: response, FETCH_STATUS: 'LOADED'}))
            message.success("Loaded");
        }).catch(err => {
            console.log(err);
            message.error("Unable to fetch. Please click on reload to refresh the list");
            setComponentState(prev => ({...prev, FETCH_STATUS: 'ERROR'}));
        }).finally(() => loading());
    }
    useEffect(() => {
        fetchTeams();
    }, []);

    useEffect(() => {
        init();
    }, [componentState.activeTeamId]);
    return (
        <>
            <Card title={<Flex justify={'space-between'} align={'center'}>
                <h5>Clients with No Identification Reports</h5>
                <div>
                    <Button type={'primary'} danger={true} onClick={() => init()} icon={<ReloadOutlined />}>Reload Page</Button>
                </div>
            </Flex>}>
                <Form.Item label={'Team'}>
                    <Select defaultValue={componentState.activeTeamId}
                            style={{ width: '200px' }}
                            allowClear={true}
                            placeholder={'-- SELECT TEAM --'}
                            onChange={(d) => setComponentState(prev => ({...prev, activeTeamId: d}))}
                            options={componentState.teamList.map(i => ({
                                ...i, label: i.nickname,
                                value: i.id
                            }))}></Select>
                </Form.Item>
                <Table size={'small'} columns={buildColumns()} dataSource={componentState.reportsList} loading={componentState.FETCH_STATUS === 'LOADING'}></Table>
            </Card>
        </>
    )
}

export default ListTable(ReportsNoIdentification);